import React, { Component } from 'react';
import { Breadcrumb, BreadcrumbItem, Modal, ModalHeader, ModalBody, Button, Label, Col, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Control, LocalForm, Errors } from 'react-redux-form';
import { Fade, Stagger } from 'react-animation-components';

const required = (val) => val && val.length;
const isNumber = (val) => !isNaN(Number(val));
const maxLength = (len) => (val) => !(val) || (val.length <= len);
const minLength = (len) => (val) => (val) && (val.length >= len);
// const validEmail = (val) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(val);

function RenderMonths({ months }) {
    if (months != null)
        return (
            <div className="col-12 col-md-5 m-1">
                <ul className="list-unstyled">
                    <Stagger in>
                        {months.map((month) => {
                            let payOne = month.payOne;
                            let payTwo = month.payTwo;
                            let emergencyFund = month.emergencyFund;
                            let investmentFund = month.investmentFund;
                            let mortgage = month.mortgage;
                            let water = month.water;
                            let housingGas = month.housingGas;
                            let electricity = month.electricity;
                            let cable = month.cable;
                            let trash = month.trash;
                            let autoGas = month.autoGas;
                            let autoMaintenance = month.autoMaintenance;
                            let groceries = month.groceries;
                            let restaurants = month.restaurants;
                            let phone = month.phone;
                            let clothing = month.clothing;
                            let householdItems = month.householdItems;
                            let funMoney = month.funMoney;
                            let subscriptions = month.subscriptions;
                            let partnerCare = month.partnerCare;
                            let childCare = month.childCare;
                            let gym = month.gym;
                            let medicine = month.medicine;
                            let doctorVisits = month.doctorVisits;
                            let healthInsurance = month.healthInsurance;
                            let autoInsurance = month.autoInsurance;
                            let homeInsurance = month.homeInsurance;
                            let debt = month.debt;
                            let giving = month.giving;
                            return (
                                <Fade in key={month._id}>
                                    <div className="table-responsive">
                                        <table className="table table-bordered">
                                            <thead className="table-dark">
                                                <tr>
                                                    <th>Amount left to budget = {Number(payOne) + Number(payTwo) - Number(emergencyFund) - Number(investmentFund) - Number(mortgage) - Number(water) - Number(housingGas) - Number(electricity) - Number(cable) - Number(trash) - Number(autoGas) - Number(autoMaintenance) - Number(groceries) - Number(restaurants) - Number(phone) - Number(clothing) - Number(householdItems) - Number(funMoney) - Number(subscriptions) - Number(partnerCare) - Number(childCare) - Number(gym) - Number(medicine) - Number(doctorVisits) - Number(healthInsurance) - Number(autoInsurance) - Number(homeInsurance) - Number(debt) - Number(giving)} AUD</th>
                                                    <th className='align-right'>{new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'short', day: '2-digit' }).format(new Date(Date.parse(month.updatedAt.toDate())))}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr className="table-primary">
                                                    <th>1. Income - Paycheck 1</th>
                                                    <th>{month.payOne} AUD</th>
                                                </tr>
                                                <tr className="table-primary">
                                                    <th>2. Income - Paycheck 2</th>
                                                    <th>{month.payTwo} AUD</th>
                                                </tr>
                                                <tr className="table-success">
                                                    <th>3. Savings - Emergency Fund</th>
                                                    <th>{month.emergencyFund} AUD</th>
                                                </tr>
                                                <tr className="table-success">
                                                    <th>4. Savings - House/Investment Fund</th>
                                                    <th>{month.investmentFund} AUD</th>
                                                </tr>
                                                <tr className="table-primary">
                                                    <th>5. Housing - Mortgage/Rent</th>
                                                    <th>{month.mortgage} AUD</th>
                                                </tr>
                                                {/* <tr className="table-primary">
                                                    <th>6. Housing - Water</th>
                                                    <th>{month.water} AUD</th>
                                                </tr>
                                                <tr className="table-primary">
                                                    <th>7. Housing - Natural Gas</th>
                                                    <th>{month.housingGas} AUD</th>
                                                </tr> */}
                                                <tr className="table-primary">
                                                    <th>8. Housing - Electricity</th>
                                                    <th>{month.electricity} AUD</th>
                                                </tr>
                                                <tr className="table-primary">
                                                    <th>9. Housing - Cable</th>
                                                    <th>{month.cable} AUD</th>
                                                </tr>
                                                {/* <tr className="table-primary">
                                                    <th>10. Housing - Trash</th>
                                                    <th>{month.trash} AUD</th>
                                                </tr> */}
                                                <tr className="table-success">
                                                    <th>11. Transportation - Gas</th>
                                                    <th>{month.autoGas} AUD</th>
                                                </tr>
                                                <tr className="table-success">
                                                    <th>12. Transportation - Maintenance</th>
                                                    <th>{month.autoMaintenance} AUD</th>
                                                </tr>
                                                <tr className="table-primary">
                                                    <th>13. Food - Groceries</th>
                                                    <th>{month.groceries} AUD</th>
                                                </tr>
                                                <tr className="table-primary">
                                                    <th>14. Food - Restaurants</th>
                                                    <th>{month.restaurants} AUD</th>
                                                </tr>
                                                <tr className="table-success">
                                                    <th>15. Personal - Phone</th>
                                                    <th>{month.phone} AUD</th>
                                                </tr>
                                                <tr className="table-success">
                                                    <th>16. Personal - Clothing</th>
                                                    <th>{month.clothing} AUD</th>
                                                </tr>
                                                <tr className="table-success">
                                                    <th>17. Personal - Household Items</th>
                                                    <th>{month.householdItems} AUD</th>
                                                </tr>
                                                <tr className="table-success">
                                                    <th>18. Personal - Fun Money</th>
                                                    <th>{month.funMoney} AUD</th>
                                                </tr>
                                                <tr className="table-success">
                                                    <th>19. Personal - Subscriptions</th>
                                                    <th>{month.subscriptions} AUD</th>
                                                </tr>
                                                <tr className="table-primary">
                                                    <th>20. Lifestyle - Partner Care</th>
                                                    <th>{month.partnerCare} AUD</th>
                                                </tr>
                                                <tr className="table-primary">
                                                    <th>21. Lifestyle - Child Care</th>
                                                    <th>{month.childCare} AUD</th>
                                                </tr>
                                                <tr className="table-success">
                                                    <th>22. Health - Gym</th>
                                                    <th>{month.gym} AUD</th>
                                                </tr>
                                                <tr className="table-success">
                                                    <th>23. Health - Medicine/Vitamins</th>
                                                    <th>{month.medicine} AUD</th>
                                                </tr>
                                                <tr className="table-success">
                                                    <th>24. Health - Doctor Visits</th>
                                                    <th>{month.doctorVisits} AUD</th>
                                                </tr>
                                                <tr className="table-primary">
                                                    <th>25. Insurance - Health</th>
                                                    <th>{month.healthInsurance} AUD</th>
                                                </tr>
                                                {/* <tr className="table-primary">
                                                    <th>26. Insurance - Auto</th>
                                                    <th>{month.autoInsurance} AUD</th>
                                                </tr>
                                                <tr className="table-primary">
                                                    <th>27. Insurance - Homeowner/Renter</th>
                                                    <th>{month.homeInsurance} AUD</th>
                                                </tr>
                                                <tr className="table-success">
                                                    <th>28. Debt - Loan/Credit Card</th>
                                                    <th>{month.debt} AUD</th>
                                                </tr> */}
                                                <tr className="table-primary">
                                                    <th>29. Giving - Church, Charity etc.</th>
                                                    <th>{month.giving} AUD</th>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </Fade>
                            );
                        })}
                    </Stagger>
                </ul>
            </div>
        );
    else
        return (
            <div></div>
        );
}

class MonthForm extends Component {

    constructor(props) {
        super(props);

        this.toggleModal = this.toggleModal.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.state = {
            isNavOpen: false,
            isModalOpen: false
        };
    }

    toggleModal() {
        this.setState({
            isModalOpen: !this.state.isModalOpen
        });
    }

    handleSubmit(values) {
        this.toggleModal();
        this.props.postMonth(values.payOne,values.payTwo, values.emergencyFund, values.investmentFund, values.mortgage, values.water, values.housingGas, values.electricity, values.cable, values.trash, values.autoGas, values.autoMaintenance, values.groceries, values.restaurants, values.phone, values.clothing, values.householdItems, values.funMoney, values.subscriptions, values.partnerCare, values.childCare, values.gym, values.medicine, values.doctorVisits, values.healthInsurance, values.autoInsurance, values.homeInsurance, values.debt, values.giving);
    }

    render() {
        return (
            <div>
                <Button outline onClick={this.toggleModal}><span className="fa fa-plus fa-lg"></span> New Month</Button>
                <Modal isOpen={this.state.isModalOpen} toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal}>Submit New Month</ModalHeader>
                    <ModalBody>
                        <LocalForm onSubmit={(values) => this.handleSubmit(values)}>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="payOne">1. Income - Paycheck 1</Label>
                                    <Control.text model=".payOne" id="payOne"
                                        className="form-control"
                                        validators={{
                                            required, minLength: minLength(1), maxLength: maxLength(15), isNumber
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".payOne"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            minLength: 'Must be greater than 1 number; ',
                                            maxLength: 'Must be 15 numbers or less; ',
                                            isNumber: 'Must be a number; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="payTwo">2. Income - Paycheck 2</Label>
                                    <Control.text model=".payTwo" id="payTwo"
                                        className="form-control"
                                        validators={{
                                            required, minLength: minLength(1), maxLength: maxLength(15), isNumber
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".payTwo"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            minLength: 'Must be greater than 1 number; ',
                                            maxLength: 'Must be 15 numbers or less; ',
                                            isNumber: 'Must be a number; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="emergencyFund">3. Savings - Emergency Fund</Label>
                                    <Control.text model=".emergencyFund" id="emergencyFund"
                                        className="form-control"
                                        validators={{
                                            required, minLength: minLength(1), maxLength: maxLength(15), isNumber
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".emergencyFund"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            minLength: 'Must be greater than 1 number; ',
                                            maxLength: 'Must be 15 numbers or less; ',
                                            isNumber: 'Must be a number; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="investmentFund">4. Savings - House/Investment Fund</Label>
                                    <Control.text model=".investmentFund" id="investmentFund"
                                        className="form-control"
                                        validators={{
                                            required, minLength: minLength(1), maxLength: maxLength(15), isNumber
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".investmentFund"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            minLength: 'Must be greater than 1 number; ',
                                            maxLength: 'Must be 15 numbers or less; ',
                                            isNumber: 'Must be a number; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="mortgage">5. Housing - Mortgage/Rent</Label>
                                    <Control.text model=".mortgage" id="mortgage"
                                        className="form-control"
                                        validators={{
                                            required, minLength: minLength(1), maxLength: maxLength(15), isNumber
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".mortgage"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            minLength: 'Must be greater than 1 number; ',
                                            maxLength: 'Must be 15 numbers or less; ',
                                            isNumber: 'Must be a number; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="water">6. Housing - Water</Label>
                                    <Control.text model=".water" id="water"
                                        className="form-control"
                                        validators={{
                                            required, minLength: minLength(1), maxLength: maxLength(15), isNumber
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".water"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            minLength: 'Must be greater than 1 number; ',
                                            maxLength: 'Must be 15 numbers or less; ',
                                            isNumber: 'Must be a number; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="housingGas">7. Housing - Natural Gas</Label>
                                    <Control.text model=".housingGas" id="housingGas"
                                        className="form-control"
                                        validators={{
                                            required, minLength: minLength(1), maxLength: maxLength(15), isNumber
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".housingGas"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            minLength: 'Must be greater than 1 number; ',
                                            maxLength: 'Must be 15 numbers or less; ',
                                            isNumber: 'Must be a number; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="electricity">8. Housing - Electricity</Label>
                                    <Control.text model=".electricity" id="electricity"
                                        className="form-control"
                                        validators={{
                                            required, minLength: minLength(1), maxLength: maxLength(15), isNumber
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".electricity"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            minLength: 'Must be greater than 1 number; ',
                                            maxLength: 'Must be 15 numbers or less; ',
                                            isNumber: 'Must be a number; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="cable">9. Housing - Cable</Label>
                                    <Control.text model=".cable" id="cable"
                                        className="form-control"
                                        validators={{
                                            required, minLength: minLength(1), maxLength: maxLength(15), isNumber
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".cable"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            minLength: 'Must be greater than 1 number; ',
                                            maxLength: 'Must be 15 numbers or less; ',
                                            isNumber: 'Must be a number; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="trash">10. Housing - Trash</Label>
                                    <Control.text model=".trash" id="trash"
                                        className="form-control"
                                        validators={{
                                            required, minLength: minLength(1), maxLength: maxLength(15), isNumber
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".trash"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            minLength: 'Must be greater than 1 number; ',
                                            maxLength: 'Must be 15 numbers or less; ',
                                            isNumber: 'Must be a number; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="autoGas">11. Transportation - Gas</Label>
                                    <Control.text model=".autoGas" id="autoGas"
                                        className="form-control"
                                        validators={{
                                            required, minLength: minLength(1), maxLength: maxLength(15), isNumber
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".autoGas"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            minLength: 'Must be greater than 1 number; ',
                                            maxLength: 'Must be 15 numbers or less; ',
                                            isNumber: 'Must be a number; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="autoMaintenance">12. Transportation - Maintenance</Label>
                                    <Control.text model=".autoMaintenance" id="autoMaintenance"
                                        className="form-control"
                                        validators={{
                                            required, minLength: minLength(1), maxLength: maxLength(15), isNumber
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".autoMaintenance"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            minLength: 'Must be greater than 1 number; ',
                                            maxLength: 'Must be 15 numbers or less; ',
                                            isNumber: 'Must be a number; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="groceries">13. Food - Groceries</Label>
                                    <Control.text model=".groceries" id="groceries"
                                        className="form-control"
                                        validators={{
                                            required, minLength: minLength(1), maxLength: maxLength(15), isNumber
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".groceries"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            minLength: 'Must be greater than 1 number; ',
                                            maxLength: 'Must be 15 numbers or less; ',
                                            isNumber: 'Must be a number; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="restaurants">14. Food - Restaurants</Label>
                                    <Control.text model=".restaurants" id="restaurants"
                                        className="form-control"
                                        validators={{
                                            required, minLength: minLength(1), maxLength: maxLength(15), isNumber
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".restaurants"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            minLength: 'Must be greater than 1 number; ',
                                            maxLength: 'Must be 15 numbers or less; ',
                                            isNumber: 'Must be a number; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="phone">15. Personal - Phone</Label>
                                    <Control.text model=".phone" id="phone"
                                        className="form-control"
                                        validators={{
                                            required, minLength: minLength(1), maxLength: maxLength(15), isNumber
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".phone"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            minLength: 'Must be greater than 1 number; ',
                                            maxLength: 'Must be 15 numbers or less; ',
                                            isNumber: 'Must be a number; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="clothing">16. Personal - Clothing</Label>
                                    <Control.text model=".clothing" id="clothing"
                                        className="form-control"
                                        validators={{
                                            required, minLength: minLength(1), maxLength: maxLength(15), isNumber
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".clothing"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            minLength: 'Must be greater than 1 number; ',
                                            maxLength: 'Must be 15 numbers or less; ',
                                            isNumber: 'Must be a number; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="householdItems">17. Personal - Household Items</Label>
                                    <Control.text model=".householdItems" id="householdItems"
                                        className="form-control"
                                        validators={{
                                            required, minLength: minLength(1), maxLength: maxLength(15), isNumber
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".householdItems"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            minLength: 'Must be greater than 1 number; ',
                                            maxLength: 'Must be 15 numbers or less; ',
                                            isNumber: 'Must be a number; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="funMoney">18. Personal - Fun Money</Label>
                                    <Control.text model=".funMoney" id="funMoney"
                                        className="form-control"
                                        validators={{
                                            required, minLength: minLength(1), maxLength: maxLength(15), isNumber
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".funMoney"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            minLength: 'Must be greater than 1 number; ',
                                            maxLength: 'Must be 15 numbers or less; ',
                                            isNumber: 'Must be a number; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="subscriptions">19. Personal - Subscriptions</Label>
                                    <Control.text model=".subscriptions" id="subscriptions"
                                        className="form-control"
                                        validators={{
                                            required, minLength: minLength(1), maxLength: maxLength(15), isNumber
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".subscriptions"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            minLength: 'Must be greater than 1 number; ',
                                            maxLength: 'Must be 15 numbers or less; ',
                                            isNumber: 'Must be a number; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="partnerCare">20. Lifestyle - Partner Care</Label>
                                    <Control.text model=".partnerCare" id="partnerCare"
                                        className="form-control"
                                        validators={{
                                            required, minLength: minLength(1), maxLength: maxLength(15), isNumber
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".partnerCare"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            minLength: 'Must be greater than 1 number; ',
                                            maxLength: 'Must be 15 numbers or less; ',
                                            isNumber: 'Must be a number; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="childCare">21. Lifestyle - Child Care</Label>
                                    <Control.text model=".childCare" id="childCare"
                                        className="form-control"
                                        validators={{
                                            required, minLength: minLength(1), maxLength: maxLength(15), isNumber
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".childCare"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            minLength: 'Must be greater than 1 number; ',
                                            maxLength: 'Must be 15 numbers or less; ',
                                            isNumber: 'Must be a number; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="gym">22. Health - Gym</Label>
                                    <Control.text model=".gym" id="gym"
                                        className="form-control"
                                        validators={{
                                            required, minLength: minLength(1), maxLength: maxLength(15), isNumber
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".gym"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            minLength: 'Must be greater than 1 number; ',
                                            maxLength: 'Must be 15 numbers or less; ',
                                            isNumber: 'Must be a number; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="medicine">23. Health - Medicine/Vitamins</Label>
                                    <Control.text model=".medicine" id="medicine"
                                        className="form-control"
                                        validators={{
                                            required, minLength: minLength(1), maxLength: maxLength(15), isNumber
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".medicine"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            minLength: 'Must be greater than 1 number; ',
                                            maxLength: 'Must be 15 numbers or less; ',
                                            isNumber: 'Must be a number; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="doctorVisits">24. Health - Doctor Visits</Label>
                                    <Control.text model=".doctorVisits" id="doctorVisits"
                                        className="form-control"
                                        validators={{
                                            required, minLength: minLength(1), maxLength: maxLength(15), isNumber
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".doctorVisits"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            minLength: 'Must be greater than 1 number; ',
                                            maxLength: 'Must be 15 numbers or less; ',
                                            isNumber: 'Must be a number; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="healthInsurance">25. Insurance - Health</Label>
                                    <Control.text model=".healthInsurance" id="healthInsurance"
                                        className="form-control"
                                        validators={{
                                            required, minLength: minLength(1), maxLength: maxLength(15), isNumber
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".healthInsurance"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            minLength: 'Must be greater than 1 number; ',
                                            maxLength: 'Must be 15 numbers or less; ',
                                            isNumber: 'Must be a number; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="autoInsurance">26. Insurance - Auto</Label>
                                    <Control.text model=".autoInsurance" id="autoInsurance"
                                        className="form-control"
                                        validators={{
                                            required, minLength: minLength(1), maxLength: maxLength(15), isNumber
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".autoInsurance"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            minLength: 'Must be greater than 1 number; ',
                                            maxLength: 'Must be 15 numbers or less; ',
                                            isNumber: 'Must be a number; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="homeInsurance">27. Insurance - Homeowner/Renter</Label>
                                    <Control.text model=".homeInsurance" id="homeInsurance"
                                        className="form-control"
                                        validators={{
                                            required, minLength: minLength(1), maxLength: maxLength(15), isNumber
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".homeInsurance"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            minLength: 'Must be greater than 1 number; ',
                                            maxLength: 'Must be 15 numbers or less; ',
                                            isNumber: 'Must be a number; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="debt">28. Debt - Loan/Credit Card</Label>
                                    <Control.text model=".debt" id="debt"
                                        className="form-control"
                                        validators={{
                                            required, minLength: minLength(1), maxLength: maxLength(15), isNumber
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".debt"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            minLength: 'Must be greater than 1 number; ',
                                            maxLength: 'Must be 15 numbers or less; ',
                                            isNumber: 'Must be a number; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row className="form-group">
                                <Col>
                                    <Label htmlFor="giving">29. Giving - Church, Charity etc.</Label>
                                    <Control.text model=".giving" id="giving"
                                        className="form-control"
                                        validators={{
                                            required, minLength: minLength(1), maxLength: maxLength(15), isNumber
                                        }}
                                    />
                                    <Errors
                                        className="text-danger"
                                        model=".giving"
                                        show="touched"
                                        messages={{
                                            required: 'Required; ',
                                            minLength: 'Must be greater than 1 number; ',
                                            maxLength: 'Must be 15 numbers or less; ',
                                            isNumber: 'Must be a number; '
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Button type="submit" className="bg-primary">
                                Submit
                            </Button>
                        </LocalForm>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

const Monthly = (props) => {
    if (props.monthsErrMess) {
        return (
            <div className="container">
                <div className="row">
                    <h4>{props.monthsErrMess}</h4>
                </div>
            </div>
        );
    }
    else
        return (
            <div className="container">
                <div className="row">
                    <Breadcrumb>
                        <BreadcrumbItem><Link to='/finance'>Finance</Link></BreadcrumbItem>
                        <BreadcrumbItem active>Monthly Budget</BreadcrumbItem>
                    </Breadcrumb>
                    <div className="col-12">
                        <h3>Monthly Budget</h3>
                        <hr />
                    </div>
                </div>
                <div className='row'>
                    <div className="col-12 offset-md-10">
                        <MonthForm postMonth={props.postMonth} />
                        <p></p>
                    </div>
                    <RenderMonths months={props.months} />
                </div>
            </div>
        );
}

export default Monthly;


// WEBPACK FOOTER //
// ./src/components/MonthlyComponent.js